/* eslint-disable react/prop-types */
import React from "react";
import { makeStyles, Typography } from "@material-ui/core";
import { useSelector } from "react-redux";
import _ from "lodash";
import getReducedHistorics from "lib/utils/historics";
import { nFormatter } from "lib/utils";
import CardComponent from "app/common/CardComponent";
import moment from "moment";
import MarginChartComponent from "./MarginChartComponent";
import ExplicabilityComponent from "../../explicability-info/ExplicabilityComponent";

const useStyles = makeStyles((theme) => ({
  aggregateContainer: {
    display: "flex",
    alignItems: "center",
    marginLeft: "5px",
  },
  chartContainer: {
    position: "relative",
    overflow: "hidden",
    flexGrow: "1",
    [theme.breakpoints.up("xs")]: {
      height: "155px",
    },
    [theme.breakpoints.up("sm")]: {
      height: "200px",
    },
    [theme.breakpoints.up("md")]: {
      height: "300px",
    },
    [theme.breakpoints.up("lg")]: {
      height: "100%",
    },
  },
  componentTitle: {
    fontWeight: "bold",
    fontSize: "14px",
    [theme.breakpoints.up("xl")]: {
      fontSize: "16px",
    },
  },
}));

function HistoryMarginComponent({ historics, historicsDataYoY }) {
  const classes = useStyles();
  const metadataSlice = useSelector((state) => state.metadata);

  const reducedFilteredHistorics = getReducedHistorics(historics);

  const marginData = {
    labels: _.map(historics, (historic) => {
      return moment(historic.date).format("MMM'YY");
    }),

    datasets: [
      {
        label: "Sales Out",
        yAxisID: "sales_out",
        type: "line",
        fill: false,
        borderColor: "#44B562",
        pointBordercolor: "#44B562",
        pointBackgroundColor: "#ffffff",
        backgroundColor: "#44B562",
        pointHoverBackgroundColor: "#ffffff",
        hoverBorderWidth: 3,
        pointHoverRadius: 6,
        data: _.map(historics, (historic) => {
          return {
            ...historic,
            title: `Date: ${historic.date}`,
            unit: metadataSlice.all.margin[0].unit,
            x: moment(historic.date).format("MMM'YY"),
            y: historic.sum_sales,
            sales_in: {
              absolute: historic.sum_sales_in,
            },
            margin: {
              absolute: historic.sum_margin,
            },
            sales: {
              absolute: historic.sum_sales,
            },
            retailer_margin: {
              absolute: historic.sum_retailer_margin,
            },
          };
        }),
      },
      {
        label: "Sales In",
        yAxisID: "sales_out",
        type: "line",
        fill: false,
        borderColor: "#00805E",
        pointBordercolor: "#00805E",
        pointBackgroundColor: "#ffffff",
        backgroundColor: "#00805E",
        borderDash: [5, 5],
        pointHoverBackgroundColor: "#ffffff",
        hoverBorderWidth: 3,
        pointHoverRadius: 6,
        data: _.map(historics, (historic) => {
          return {
            ...historic,
            title: `Date: ${historic.date}`,
            x: moment(historic.date).format("MMM'YY"),
            y: historic.sum_sales_in,
            sales_in: {
              absolute: historic.sum_sales_in,
            },
            margin: {
              absolute: historic.sum_margin,
            },
            sales: {
              absolute: historic.sum_sales,
            },
            retailer_margin: {
              absolute: historic.sum_retailer_margin,
            },
          };
        }),
      },
      {
        label: "Margin",
        yAxisID: "margin",
        type: "bar",
        borderColor: "rgba(117, 182, 156, 0.3)",
        pointBordercolor: "rgba(117, 182, 156, 0.3)",
        pointBackgroundColor: "#ffffff",
        backgroundColor: "rgba(117, 182, 156, 0.3)",
        data: _.map(historics, (historic) => {
          return {
            ...historic,
            title: `Date: ${historic.date}`,
            unit: metadataSlice.all.margin[0].unit,
            x: moment(historic.date).format("MMM'YY"),
            y: historic.sum_margin,
            sales_in: {
              absolute: historic.sum_sales_in,
            },
            margin: {
              absolute: historic.sum_margin,
            },
            sales: {
              absolute: historic.sum_sales,
            },
            retailer_margin: {
              absolute: historic.sum_retailer_margin,
            },
          };
        }),
      },
      {
        label: "Reatiler Margin",
        yAxisID: "margin",
        type: "bar",
        borderColor: "rgba(184, 220, 206, 1)",
        pointBordercolor: "rgba(184, 220, 206, 1)",
        pointBackgroundColor: "#ffffff",
        backgroundColor: "rgba(184, 220, 206, 1)",
        data: _.map(historics, (historic) => {
          return {
            ...historic,
            title: `Date: ${historic.date}`,
            unit: metadataSlice.all.margin[0].unit,
            x: moment(historic.date).format("MMM'YY"),
            y: historic.sum_retailer_margin,
            sales_in: {
              absolute: historic.sum_sales_in,
            },
            margin: {
              absolute: historic.sum_margin,
            },
            sales: {
              absolute: historic.sum_sales,
            },
            retailer_margin: {
              absolute: historic.sum_retailer_margin,
            },
          };
        }),
      },
    ],
  };

  return (
    <CardComponent
      title={
        <>
          <Typography variant="body1" className={classes.componentTitle}>
            {`Sales & Margin (${metadataSlice.all.margin[0].unit})`}
            <ExplicabilityComponent tooltipText="Historical values for Sales and Margin  in the last 12 months" />
          </Typography>
          <div className={classes.aggregateContainer}>
            <Typography variant="caption">Annual Aggregate</Typography>
            <Typography
              variant="subtitle2"
              style={{
                fontWeight: "bold",
                marginLeft: "10px",
              }}
            >
              {nFormatter(reducedFilteredHistorics.margin)}
            </Typography>
          </div>
        </>
      }
      body={
        <div className={classes.chartContainer}>
          <MarginChartComponent
            data={marginData}
            historicsDataYoY={historicsDataYoY}
          />
        </div>
      }
    />
  );
}

export default HistoryMarginComponent;
